import { IconProps } from "./types";
import { SVGIcon } from "./svg-icon";

export const PayAlt = ({
  size,
  type,
  theme,
  className,
  dataTestId = "pay-alt-icon",
}: IconProps) => (
  <SVGIcon
    size={size}
    type={type}
    theme={theme}
    className={className}
    dataTestId={dataTestId}
  >
    <path d="M12.772 0.219052C13.0321 -0.0423499 13.4542 -0.0440622 13.7148 0.215228L15.7553 2.24588C15.8811 2.37106 15.9515 2.54145 15.951 2.71919C15.9504 2.89694 15.8788 3.06733 15.7522 3.1925L13.6984 5.22316C13.4361 5.48245 13.014 5.48074 12.7556 5.21933C12.4971 4.95793 12.5002 4.53583 12.7625 4.27654L13.6627 3.38646H9.33317C8.96498 3.38646 8.6665 3.68494 8.6665 4.05312V4.76156C8.6665 5.12975 8.36803 5.42822 7.99984 5.42822C7.63165 5.42822 7.33317 5.12975 7.33317 4.76156V4.05312C7.33317 2.94856 8.2286 2.05312 9.33317 2.05312H13.6683L12.7727 1.16185C12.5122 0.902559 12.5118 0.480454 12.772 0.219052Z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.37484 7.33307C0.638458 7.33307 0.0415039 7.93003 0.0415039 8.66641V14.6664C0.0415039 15.4028 0.638458 15.9997 1.37484 15.9997H14.6248C15.3611 15.9997 15.9581 15.4028 15.9581 14.6664V8.66641C15.9581 7.93003 15.3611 7.33307 14.6248 7.33307H1.37484ZM9.74774 8.66641H14.6248V14.6664H9.74474C10.5359 13.9722 11.0036 12.8287 11.0036 11.6651C11.0036 10.5029 10.5371 9.3609 9.74774 8.66641ZM6.25305 8.66641H1.37484V14.6664H6.25605C5.46485 13.9722 4.99723 12.8287 4.99723 11.6651C4.99723 10.5029 5.46367 9.3609 6.25305 8.66641ZM6.33057 11.6651C6.33057 10.2067 7.22482 9.32526 8.00039 9.32526C8.77597 9.32526 9.67022 10.2067 9.67022 11.6651C9.67022 13.1235 8.77597 14.0049 8.00039 14.0049C7.22482 14.0049 6.33057 13.1235 6.33057 11.6651Z"
    />
  </SVGIcon>
);
